import { Record } from 'immutable';
import { getStore } from '../utils/persist';
import { RootState } from './types';

// types
export type IQuote = any;

export interface IQuotesState {
  quotes: IQuote[];
}

enum ActionTypes {
  SetQuotes = 'Quotes/SetQuotes',
}

interface ISetQuotes {
  type: ActionTypes.SetQuotes;
  payload: {
    quotes: IQuote[];
  };
}

type Actions = ISetQuotes;

// state
const persistedStore = getStore();

const record = Record<IQuotesState>({
  // `bp` is the legacy key this slice was persisted under; read it so a session
  // started before the rename keeps its quotes.
  quotes: persistedStore?.quotes?.quotes || persistedStore?.bp?.quotes || [],
});

export class QuotesState extends record implements IQuotesState {}

// reducer
export default function reducer(state = new QuotesState(), action: Actions) {
  switch (action.type) {
    case ActionTypes.SetQuotes: {
      return state.set('quotes', action.payload.quotes);
    }

    default: {
      return state;
    }
  }
}

// actions
export const setQuotes = (quotes: IQuote[]): ISetQuotes => ({
  type: ActionTypes.SetQuotes,
  payload: {
    quotes,
  },
});

// selectors
export const getQuotes = (rooState: RootState): IQuote[] => rooState.getIn(['quotes', 'quotes']) as IQuote[];

export const getQuote: IQuote = (quoteID: string) => (rooState: RootState) =>
  getQuotes(rooState).find(q => q.id === quoteID || q.quoteNumber === quoteID);
